module.exports = __webpack_public_path__ + "141d4a85/img/product-icon-grey.b248963c.svg";